require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /builds/development/frontend/widgets/widgets/node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module id = ../../node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module chunks = widget-6.25.3